import React from "react";
import PropTypes from "prop-types";
import { Breadcrumb as AntBreadcrumb } from "antd";
import { UiBreadcrumb } from "./Breadcrumb.style";
/**
 * 麵包屑
 */

const Breadcrumb = ({
  data = [],
  mb
}) => {
  return /*#__PURE__*/React.createElement(UiBreadcrumb, {
    mb: mb
  }, /*#__PURE__*/React.createElement(AntBreadcrumb, null, data.map((item, index, arr) => {
    return /*#__PURE__*/React.createElement(AntBreadcrumb.Item, {
      key: item.name
    }, /*#__PURE__*/React.createElement("a", {
      href: item.path,
      disabled: arr.length === index + 1
    }, item.oneClassIcon && item.oneClassIcon, item.icon && /*#__PURE__*/React.createElement("i", {
      className: "material-icons-outlined"
    }, item.icon), item.name));
  })));
};

export default Breadcrumb;
Breadcrumb.propTypes = {
  data: PropTypes.array,
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};